module.exports = __webpack_public_path__ + "media/new.76673faa.mp3";